module.exports = __webpack_public_path__ + "static/media/gitlab.707c56c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gitlab.svg
// module id = 113
// module chunks = 0